var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenussoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1246,
    height: 1246,
    viewBox: "0 0 1246 1246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9405_17331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851.469 533.617C851.469 533.617 745.718 550.228 661.489 502.36C587.906 460.542 490.562 367.658 441 319.002C435.397 314.507 400.32 284.903 353.184 303.176C306.049 321.45 299.682 380.35 298.239 384.678L278 537.002C286 516.002 297.208 504.194 319.332 501.79C348.672 498.423 387.421 536.611 388.864 538.534C447.542 597.202 508.517 660.392 567.195 719.063C581.846 731.271 594.439 738.966 624.276 738.966C654.114 738.966 666.78 723.867 672.552 719.063C701.41 690.207 851.469 533.617 851.469 533.617Z",
    fill: "#0284FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.469 533.617C851.469 533.617 745.718 550.228 661.489 502.36C587.906 460.542 490.562 367.658 441 319.002C435.397 314.507 400.32 284.903 353.184 303.176C306.049 321.45 299.682 380.35 298.239 384.678L277.5 541.002C284.715 519.362 297.208 504.194 319.332 501.79C348.672 498.423 387.421 536.611 388.864 538.534C447.542 597.202 508.517 660.392 567.195 719.063C581.846 731.271 594.439 738.966 624.276 738.966C654.114 738.966 666.78 723.867 672.552 719.063C701.41 690.207 851.469 533.617 851.469 533.617Z",
    fill: "#0284FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9405_17331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851.503 530.992C851.503 530.992 744.515 549.182 660.289 501.314C586.706 459.495 500.829 376.387 441 319.001C433.369 312.896 397.476 286.03 353.52 303.071C306.385 321.345 299.713 380.245 298.27 384.573L278 540.501C285.215 518.861 290.116 498.6 312.241 496.195C341.58 492.829 371.113 519.691 396.866 545.439C422.814 571.382 446.422 595.175 471 620.501C502.002 652.445 533.958 685.923 567.5 719.124C581.236 731.029 594.281 739.449 624.582 738.965C652.959 738.488 666.4 724.012 673.421 717.907C702.28 689.052 851.503 530.992 851.503 530.992Z",
    fill: "url(#paint0_radial_9405_17331)",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.951 513.081C366.951 513.081 336.12 481.335 302.543 498.43C285.019 508.323 278.428 533.228 278.428 533.228L244.24 786.278C244.24 786.278 234.048 863.858 340.47 872.921C440.515 881.438 445.4 814.055 445.4 814.055L471.345 619.919L366.951 513.081Z",
    fill: "url(#paint1_radial_9405_17331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.105 522.544C589.435 575.28 688.949 417.579 794.897 313.548C800.801 307.75 838.997 285.742 885.979 303.96C932.961 322.178 946.379 369.817 947.817 374.131L971.903 556.176C964.713 534.603 928.806 517.775 898.92 517.775C869.678 514.419 851.593 537.721 850.155 539.639C791.669 598.126 735.451 656.022 676.964 714.512C671.69 718.826 654.474 739.448 624.273 738.964C595.989 738.487 581.233 733.779 562.918 714.512C533.675 685.746 404.869 551.309 376.105 522.544Z",
    fill: "url(#paint2_radial_9405_17331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.266 384.574C298.266 384.574 308.339 297.272 382.82 297.272C417.999 297.001 438.999 317.001 438.999 317.001L513.467 387.321L580.272 445.289C467.134 470.487 413.905 466.747 298.266 384.574Z",
    fill: "url(#paint3_radial_9405_17331)",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.699 162.044C474.699 80.2814 541.658 14 624.255 14C706.851 14 773.812 80.2814 773.812 162.044C773.812 177.975 770.023 221.547 722.295 284.641C674.569 347.735 635.887 394.226 624.255 394.226C612.622 394.226 567.756 347.735 524.551 284.641C481.346 221.547 474.699 177.975 474.699 162.044ZM626.79 211.719C663.189 211.719 692.697 181.644 692.697 144.546C692.697 107.447 663.189 77.3724 626.79 77.3724C590.392 77.3724 560.885 107.447 560.885 144.546C560.885 181.644 590.392 211.719 626.79 211.719Z",
    fill: "url(#paint4_radial_9405_17331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M562.306 272.995C491.738 224.832 474.699 153.5 474.699 153.5C473.048 195.019 493.436 241.44 527.46 289.602C572.043 352.711 611.297 394.23 624.795 394.23C638.294 394.23 689.289 327.492 689.289 327.492C689.289 327.492 632.875 321.157 562.306 272.995Z",
    fill: "url(#paint5_linear_9405_17331)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M879.794 508.808C879.794 508.808 910.627 477.062 944.204 494.156C961.729 504.049 968.317 528.954 968.317 528.954L1002.51 782.006C1002.51 782.006 1015.5 864.21 909.078 873.274C809.03 881.798 801.35 809.783 801.35 809.783L775.377 614.424L879.794 508.808Z",
    fill: "url(#paint6_radial_9405_17331)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.436 1181.22C143.799 1183.46 140.351 1185.28 136.092 1186.7C132.035 1187.91 127.268 1188.52 121.792 1188.52C114.49 1188.52 108.405 1187.61 103.537 1185.79C98.8716 1183.96 95.8291 1180.82 94.4092 1176.36C88.73 1158.51 84.0647 1144.11 80.4137 1133.15C76.7627 1122 73.923 1112.26 71.8947 1103.94H70.3734C69.7649 1115.91 69.2578 1126.86 68.8522 1136.8C68.6494 1146.54 68.4465 1156.07 68.2437 1165.4C68.2437 1174.73 68.0408 1184.16 67.6352 1193.69C67.4323 1203.23 67.0267 1213.78 66.4182 1225.34C63.7814 1226.35 60.3332 1227.16 56.0737 1227.77C51.8142 1228.59 47.5547 1228.99 43.2952 1228.99C34.3706 1228.99 27.3728 1227.57 22.302 1224.73C17.434 1221.89 15 1216.72 15 1209.21L23.8232 1054.05C25.4459 1051.41 28.9955 1048.57 34.472 1045.52C39.9485 1042.48 47.6562 1040.96 57.595 1040.96C68.3451 1040.96 76.7627 1042.69 82.8477 1046.13C88.9325 1049.38 93.395 1054.75 96.2349 1062.26C98.06 1067.13 99.9874 1072.71 102.016 1079C104.247 1085.28 106.377 1091.77 108.405 1098.46C110.636 1105.16 112.766 1111.86 114.794 1118.55C116.822 1125.04 118.648 1130.92 120.271 1136.19H121.792C126.66 1119.16 131.528 1102.72 136.396 1086.91C141.263 1070.88 145.726 1057.49 149.783 1046.74C152.825 1045.12 156.679 1043.8 161.344 1042.79C166.212 1041.57 171.587 1040.96 177.469 1040.96C187.408 1040.96 195.522 1042.48 201.809 1045.52C208.097 1048.36 211.748 1052.53 212.762 1058C213.573 1062.06 214.385 1068.34 215.197 1076.86C216.211 1085.18 217.225 1094.61 218.239 1105.16C219.253 1115.71 220.267 1126.86 221.282 1138.62C222.296 1150.39 223.208 1161.75 224.019 1172.71C225.033 1183.46 225.845 1193.39 226.453 1202.52C227.062 1211.45 227.468 1218.34 227.671 1223.21C224.222 1225.24 220.572 1226.66 216.717 1227.47C213.067 1228.48 208.3 1228.99 202.418 1228.99C194.71 1228.99 188.219 1227.67 182.946 1225.03C177.672 1222.4 174.832 1217.23 174.427 1209.52C173.21 1187.41 172.398 1167.53 171.993 1149.89C171.79 1132.24 171.384 1117.43 170.776 1105.46H169.255C167.227 1113.38 164.285 1123.31 160.432 1135.28C156.577 1147.24 151.912 1162.56 146.436 1181.22Z",
    fill: "url(#paint7_linear_9405_17331)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M334.455 1231.43C322.487 1231.43 311.331 1229.8 300.987 1226.55C290.846 1223.11 281.921 1218.04 274.213 1211.35C266.708 1204.65 260.725 1196.23 256.262 1186.09C252.003 1175.95 249.873 1164.09 249.873 1150.5C249.873 1137.1 252.003 1125.65 256.262 1116.12C260.725 1106.38 266.506 1098.47 273.605 1092.38C280.704 1086.09 288.817 1081.53 297.945 1078.69C307.072 1075.65 316.402 1074.12 325.936 1074.12C336.686 1074.12 346.422 1075.75 355.144 1079C364.068 1082.24 371.675 1086.7 377.962 1092.38C384.453 1098.06 389.422 1104.85 392.871 1112.77C396.521 1120.68 398.347 1129.3 398.347 1138.63C398.347 1145.52 396.42 1150.8 392.566 1154.45C388.712 1158.1 383.337 1160.44 376.441 1161.45L301.291 1172.71C303.522 1179.4 308.086 1184.47 314.983 1187.92C321.879 1191.17 329.79 1192.78 338.714 1192.78C347.03 1192.78 354.84 1191.77 362.141 1189.74C369.646 1187.51 375.731 1184.98 380.396 1182.14C383.641 1184.16 386.38 1187 388.611 1190.65C390.842 1194.3 391.958 1198.16 391.958 1202.22C391.958 1211.35 387.698 1218.14 379.18 1222.6C372.689 1226.05 365.386 1228.38 357.273 1229.6C349.16 1230.81 341.554 1231.43 334.455 1231.43ZM325.936 1111.86C321.068 1111.86 316.808 1112.67 313.157 1114.29C309.709 1115.91 306.87 1118.04 304.638 1120.68C302.407 1123.11 300.683 1125.95 299.466 1129.2C298.451 1132.24 297.843 1135.38 297.64 1138.63L349.667 1130.11C349.059 1126.05 346.827 1122 342.974 1117.94C339.12 1113.88 333.44 1111.86 325.936 1111.86Z",
    fill: "url(#paint8_linear_9405_17331)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M516.951 1132.85C516.951 1126.56 515.126 1122 511.475 1119.16C508.027 1116.12 503.26 1114.59 497.175 1114.59C493.119 1114.59 489.062 1115.1 485.005 1116.12C481.151 1117.13 477.805 1118.65 474.965 1120.68V1226.25C472.936 1226.86 469.691 1227.47 465.229 1228.08C460.97 1228.68 456.507 1228.99 451.842 1228.99C447.38 1228.99 443.323 1228.68 439.672 1228.08C436.224 1227.47 433.283 1226.25 430.849 1224.42C428.415 1222.6 426.488 1220.17 425.068 1217.12C423.851 1213.88 423.242 1209.72 423.242 1204.65V1113.38C423.242 1107.9 424.358 1103.44 426.589 1099.99C429.023 1096.54 432.269 1093.4 436.325 1090.56C443.221 1085.69 451.842 1081.74 462.186 1078.69C472.734 1075.65 484.396 1074.12 497.175 1074.12C520.095 1074.12 537.742 1079.2 550.115 1089.34C562.487 1099.28 568.674 1113.17 568.674 1131.02V1226.25C566.645 1226.86 563.4 1227.47 558.938 1228.08C554.678 1228.68 550.216 1228.99 545.551 1228.99C541.089 1228.99 537.032 1228.68 533.381 1228.08C529.933 1227.47 526.991 1226.25 524.558 1224.42C522.124 1222.6 520.197 1220.17 518.777 1217.12C517.56 1213.88 516.951 1209.72 516.951 1204.65V1132.85Z",
    fill: "url(#paint9_linear_9405_17331)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M600.621 1080.82C602.649 1080.21 605.794 1079.61 610.053 1079C614.515 1078.38 619.079 1078.08 623.744 1078.08C628.206 1078.08 632.162 1078.38 635.609 1079C639.261 1079.61 642.304 1080.82 644.737 1082.65C647.171 1084.47 648.997 1087 650.214 1090.25C651.634 1093.29 652.344 1097.35 652.344 1102.42V1167.83C652.344 1176.15 654.372 1182.14 658.429 1185.79C662.485 1189.24 668.367 1190.96 676.075 1190.96C680.74 1190.96 684.493 1190.55 687.332 1189.74C690.374 1188.93 692.707 1188.12 694.33 1187.31V1080.82C696.359 1080.21 699.502 1079.61 703.762 1079C708.221 1078.38 712.791 1078.08 717.45 1078.08C721.916 1078.08 725.87 1078.38 729.32 1079C732.97 1079.61 736.012 1080.82 738.445 1082.65C740.879 1084.47 742.704 1087 743.921 1090.25C745.345 1093.29 746.05 1097.35 746.05 1102.42V1194.91C746.05 1205.05 741.791 1212.66 733.274 1217.73C726.174 1222.2 717.657 1225.54 707.716 1227.77C697.981 1230.2 687.332 1231.43 675.77 1231.43C664.818 1231.43 654.676 1230.2 645.346 1227.77C636.219 1225.34 628.308 1221.59 621.614 1216.52C614.921 1211.45 609.749 1204.96 606.098 1197.04C602.446 1188.93 600.621 1179.19 600.621 1167.83V1080.82Z",
    fill: "url(#paint10_linear_9405_17331)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M902.447 1182.44C902.447 1197.86 896.667 1209.92 885.101 1218.64C873.543 1227.37 856.502 1231.73 833.992 1231.73C825.468 1231.73 817.56 1231.12 810.259 1229.9C802.959 1228.68 796.668 1226.86 791.393 1224.42C786.326 1221.79 782.268 1218.54 779.226 1214.69C776.384 1210.83 774.967 1206.27 774.967 1201C774.967 1196.13 775.977 1192.08 778.009 1188.83C780.035 1185.38 782.468 1182.54 785.309 1180.31C791.193 1183.55 797.885 1186.5 805.392 1189.13C813.1 1191.57 821.922 1192.78 831.863 1192.78C838.147 1192.78 842.917 1191.87 846.159 1190.04C849.609 1188.22 851.33 1185.79 851.33 1182.74C851.33 1179.9 850.114 1177.67 847.68 1176.05C845.247 1174.43 841.189 1173.11 835.513 1172.1L826.381 1170.27C808.738 1166.82 795.555 1161.45 786.83 1154.14C778.313 1146.64 774.055 1135.99 774.055 1122.2C774.055 1114.69 775.672 1107.9 778.922 1101.81C782.164 1095.73 786.727 1090.66 792.61 1086.6C798.493 1082.54 805.489 1079.4 813.605 1077.17C821.922 1074.94 831.047 1073.82 840.988 1073.82C848.489 1073.82 855.492 1074.43 861.984 1075.65C868.676 1076.66 874.455 1078.29 879.322 1080.52C884.189 1082.75 888.046 1085.69 890.881 1089.34C893.722 1092.79 895.146 1096.94 895.146 1101.81C895.146 1106.48 894.234 1110.54 892.409 1113.99C890.784 1117.23 888.655 1119.97 886.014 1122.2C884.396 1121.18 881.963 1120.17 878.714 1119.16C875.471 1117.94 871.918 1116.92 868.067 1116.12C864.21 1115.1 860.255 1114.29 856.197 1113.68C852.347 1113.07 848.793 1112.77 845.551 1112.77C838.859 1112.77 833.688 1113.58 830.031 1115.2C826.381 1116.62 824.556 1118.95 824.556 1122.2C824.556 1124.43 825.572 1126.26 827.597 1127.67C829.63 1129.09 833.481 1130.41 839.163 1131.63L848.593 1133.76C868.067 1138.22 881.859 1144.41 889.968 1152.32C898.285 1160.03 902.447 1170.07 902.447 1182.44Z",
    fill: "url(#paint11_linear_9405_17331)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.19 1182.44C1052.19 1197.86 1046.41 1209.92 1034.85 1218.64C1023.29 1227.37 1006.25 1231.73 983.738 1231.73C975.214 1231.73 967.306 1231.12 960.005 1229.9C952.705 1228.68 946.414 1226.86 941.139 1224.42C936.072 1221.79 932.014 1218.54 928.972 1214.69C926.131 1210.83 924.713 1206.27 924.713 1201C924.713 1196.13 925.73 1192.08 927.755 1188.83C929.781 1185.38 932.214 1182.54 935.056 1180.31C940.939 1183.55 947.631 1186.5 955.138 1189.13C962.847 1191.57 971.668 1192.78 981.609 1192.78C987.893 1192.78 992.663 1191.87 995.906 1190.04C999.355 1188.22 1001.08 1185.79 1001.08 1182.74C1001.08 1179.9 999.86 1177.67 997.426 1176.05C994.993 1174.43 990.935 1173.11 985.259 1172.1L976.134 1170.27C958.484 1166.82 945.301 1161.45 936.576 1154.14C928.059 1146.64 923.801 1135.99 923.801 1122.2C923.801 1114.69 925.425 1107.9 928.668 1101.81C931.91 1095.73 936.48 1090.66 942.356 1086.6C948.239 1082.54 955.242 1079.4 963.351 1077.17C971.668 1074.94 980.793 1073.82 990.734 1073.82C998.242 1073.82 1005.24 1074.43 1011.73 1075.65C1018.42 1076.66 1024.2 1078.29 1029.07 1080.52C1033.94 1082.75 1037.79 1085.69 1040.63 1089.34C1043.47 1092.79 1044.89 1096.94 1044.89 1101.81C1044.89 1106.48 1043.98 1110.54 1042.15 1113.99C1040.53 1117.23 1038.4 1119.97 1035.76 1122.2C1034.14 1121.18 1031.71 1120.17 1028.46 1119.16C1025.22 1117.94 1021.66 1116.92 1017.81 1116.12C1013.96 1115.1 1010 1114.29 1005.94 1113.68C1002.09 1113.07 998.546 1112.77 995.297 1112.77C988.605 1112.77 983.434 1113.58 979.784 1115.2C976.134 1116.62 974.302 1118.95 974.302 1122.2C974.302 1124.43 975.318 1126.26 977.35 1127.67C979.376 1129.09 983.227 1130.41 988.909 1131.63L998.339 1133.76C1017.81 1138.22 1031.61 1144.41 1039.72 1152.32C1048.04 1160.03 1052.19 1170.07 1052.19 1182.44Z",
    fill: "url(#paint12_linear_9405_17331)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.73 1152.62C1231.73 1165.2 1229.8 1176.45 1225.95 1186.4C1222.09 1196.13 1216.61 1204.35 1209.51 1211.04C1202.62 1217.73 1194.3 1222.81 1184.56 1226.25C1174.83 1229.7 1163.98 1231.43 1152.01 1231.43C1140.04 1231.43 1129.2 1229.6 1119.46 1225.95C1109.72 1222.3 1101.3 1217.12 1094.2 1210.43C1087.31 1203.53 1081.93 1195.22 1078.08 1185.48C1074.22 1175.75 1072.3 1164.79 1072.3 1152.62C1072.3 1140.66 1074.22 1129.8 1078.08 1120.07C1081.93 1110.34 1087.31 1102.12 1094.2 1095.42C1101.3 1088.53 1109.72 1083.26 1119.46 1079.61C1129.2 1075.95 1140.04 1074.12 1152.01 1074.12C1163.98 1074.12 1174.83 1076.05 1184.56 1079.91C1194.3 1083.56 1202.62 1088.84 1209.51 1095.73C1216.61 1102.42 1222.09 1110.64 1225.95 1120.37C1229.8 1130.11 1231.73 1140.86 1231.73 1152.62ZM1125.24 1152.62C1125.24 1165 1127.57 1174.53 1132.24 1181.22C1137.11 1187.72 1143.8 1190.96 1152.31 1190.96C1160.84 1190.96 1167.33 1187.61 1171.79 1180.92C1176.46 1174.23 1178.78 1164.79 1178.78 1152.62C1178.78 1140.46 1176.46 1131.12 1171.79 1124.63C1167.12 1117.94 1160.53 1114.59 1152.01 1114.59C1143.49 1114.59 1136.9 1117.94 1132.24 1124.63C1127.57 1131.12 1125.24 1140.46 1125.24 1152.62Z",
    fill: "url(#paint13_linear_9405_17331)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9405_17331",
    x: 277.5,
    y: 297.277,
    width: 573.969,
    height: 441.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.517647 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9405_17331"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9405_17331",
    x: 278,
    y: 297.492,
    width: 573.504,
    height: 441.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.517647 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9405_17331"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.197 343.567) rotate(53.0411) scale(327.984 354.174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239693,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553947,
    stopColor: "#065FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799302,
    stopColor: "#0360B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(308.353 890.418) rotate(-84.4751) scale(443.588 254.043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01408F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(849.546 393.504) rotate(-86.9607) scale(542.492 585.764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#83C3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#83C3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#4BA7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0284FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(433.314 302.693) rotate(96.4787) scale(192.161 362.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#0284FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(735.216 21.2194) rotate(106.566) scale(389.161 306.022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448918,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825117,
    stopColor: "#0576DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9405_17331",
    x1: 592.184,
    y1: 243.723,
    x2: 533.963,
    y2: 359.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEDFFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_9405_17331",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(938.556 885.254) rotate(-95.6386) scale(520.602 298.149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01408F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9405_17331",
    x1: 623.362,
    y1: 1040.96,
    x2: 623.362,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9405_17331",
    x1: 623.363,
    y1: 1040.96,
    x2: 623.363,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9405_17331",
    x1: 623.363,
    y1: 1040.96,
    x2: 623.363,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9405_17331",
    x1: 623.361,
    y1: 1040.96,
    x2: 623.361,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9405_17331",
    x1: 623.361,
    y1: 1040.96,
    x2: 623.361,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9405_17331",
    x1: 623.36,
    y1: 1040.96,
    x2: 623.36,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9405_17331",
    x1: 623.364,
    y1: 1040.96,
    x2: 623.364,
    y2: 1231.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2896FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#46A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0284FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenussoLogo);
export default __webpack_public_path__ + "static/media/Menusso_logo.137d3f126e8ddbf7acdd44ecef0860a9.svg";
export { ForwardRef as ReactComponent };